<template>
    <div class="signInBox">
        <div class="head">
            <img src="../../../assets/img/wxPay/signin.jpg" />
        </div>
        <div class="content">
            <div class="block" v-for="(item, index) in signInRoutes" :key="index">
                <div :class="[{'circle-yellow':item.isSignin},{'circle-gray':!item.isSignin}]">
                    <p>+{{item.score}}</p>
                </div>
                <p>{{item.lable}}</p>
            </div>
        </div>
        <div class="margin-15">
            <div class="footer">
                <h4>本月已签到<span>{{count}}</span>天，共获得<span>{{totalScore}}个积分</span></h4>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "signIn2",
        data(){
            return{
                openid:'',
                rule:'', //当前活动
                signInRoutes:[], //本次活动的签到路径
                count:'', //本次活动总共签到的天数
                score:'', //本次活动当前签到获取的积分
                totalScore:'', //本次活动签到获取的总积分
            }
        },
        mounted() {
            this.openid = localStorage.getItem('openId')
            let dt = new URLSearchParams()
            dt.append('wxOpenId', this.openid)
            this.$http.post('/sangto-wrm/activity/signin2/signin',dt).then(({data})=>{
                if(data.data == null){
                    this.UI.Dialog.alert({
                        title:'提示',
                        content:'无签到活动',
                        cancelText: '取消',
                        confirmText: '确定'
                    })
                    return
                }
                let item = data.data
                this.rule = item.rule
                this.signInRoutes = item.signInRoutes
                this.count = item.count
                this.score = item.score
                this.totalScore = item.totalScore
                if(data.data.message){
                    this.UI.Dialog.alert({
                        title:'温馨提示',
                        content:data.data.message,
                        cancelText: '取消',
                        confirmText: '确定'
                    })
                }else{
                    this.UI.Dialog.alert({
                        title:'签到成功',
                        content:`本次已获取${this.score}个积分`,
                        cancelText: '取消',
                        confirmText: '确定'
                    })

                    let dt = new URLSearchParams()
                    dt.append('openid',localStorage.getItem("openId"))
                    this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt).then(({data})=>{ //使用openid获取会员信息
                        if(data.code == 200 && data.data != null){
                            // console.log(data.data)
                            let dataStr = JSON.stringify(data.data)
                            if(data.data.cardAccount){
                                localStorage.setItem("login", '1')
                            }else{
                                localStorage.setItem("login", '0')
                            }

                            localStorage.setItem("userData", dataStr)
                        }else{
                            this.UI.Toast.failed(data.message)
                        }
                    })
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
.signInBox{
    position: relative;
    width: 100%;
    background-color: #fff;
    .head{
        width: 100%;
        height: 158px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .content{
        margin: 5px;
        overflow: hidden;
    }
    .block{
        width: 20%;
        float: left;
        clear:right;
        margin-bottom: 10px;
        margin-top: 10px;
        text-align: center;
        font-size: 12px;
    }
    .circle-yellow {
        border-radius: 50%;
        border: 4px solid #ffe867;
        background-color: #ffd700;
        color: #b28247;
        width: 30px;
        height: 30px;
        margin: 0 auto;
        p{
            font-size: 10px;
        }
    }
    .circle-gray {
        border-radius: 50%;
        border: 4px solid #efefef;
        background-color: #e6e6e6;
        color: #a0a0a0;
        width: 30px;
        height: 30px;
        margin: 0 auto;
        p{
            font-size: 10px;
        }
    }
    .footer h4{
        text-align: center;
        color: #a0a0a0;
        font-size: 16px;
        line-height: 50px;
        span{
            color: #b28247;
        }
    }
}
</style>
